import React from 'react'

import dayjs from 'dayjs'
import { useLocation, useParams } from 'react-router-dom'

import { ChallengesList, ParticipantsList } from '../components'
import CreateChallengeComponent from '../components/forms/ChallengeForm'
import { ChallengesProvider } from '../context/ChallengesContext'
import { Challenge, ChallengeStatus } from '../types'

const now = dayjs().format('YYYY-MM-DD')
const month = dayjs().format('YYYY-MM-DD')

export const INITIAL_VALUE: Challenge = {
  title: '',
  description: '',
  category: '',
  hashtags: [],
  instructions: '',
  startDate: now,
  endDate: month,
  status: ChallengeStatus.ACTIVE,
  image: null,
  altText: '',
  participants: [],
  points: 1,
}

const ChallengePage = () => {
  const { part } = useParams<{ part: string }>()
  const { state } = useLocation() as { state?: { challenge?: Challenge } }

  const challengeFromState = state?.challenge
  const editChallengeId =
    part && part !== 'crear-desafio' && part !== 'editar-desafio'
      ? part
      : undefined
  const showForm = part === 'crear-desafio' || part === 'editar-desafio'
  const initialChallenge = challengeFromState
    ? { ...challengeFromState }
    : { ...INITIAL_VALUE, id: undefined }

  return (
    <ChallengesProvider
      initialState={initialChallenge}
      editChallengeId={editChallengeId}
    >
      {showForm ? (
        <CreateChallengeComponent />
      ) : editChallengeId !== undefined ? (
        <ParticipantsList />
      ) : (
        <ChallengesList />
      )}
    </ChallengesProvider>
  )
}

export default ChallengePage
